import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import AuthUser from '../pageauth/AuthUser';
import { Toaster, toast } from 'sonner';
import { DescargarApp } from '../componentes/Cuerpos/DescargarApp';
import ManejoNotificacionesEnAndroid from '../ManejoNotificacionesEnAndroid';
import { HeaderRemoteWork } from '../componentes/headers/HeaderRemoteWork';
import { FooterRemoteWork } from '../componentes/footers/FooterRemoteWork';
import { SidebarRemoteWork } from '../componentes/Cuerpos/remotework/SidebarRemoteWork';

export const LayoutClientRemoteWork = () => {
  const { getRol, getModule } = AuthUser()
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (getRol() != "client") {
      navigate('/');
    } else {
      const url = new URL(window.location.href);
      if (url.pathname == "/remotework") {
        if (getModule() != "Remotework") {
          navigate('/');
        }
      }

      if (url.pathname == "/playa") {
        if (getModule() != "Playa") {
          navigate('/');
        }
      }
      if (url.pathname == "/shop") {
        if (getModule() != "Shop") {
          navigate('/');
        }
      }
    }
  }, [])

  return (
    <>
      <Toaster expand visibleToasts={1} />
      <SidebarRemoteWork />
      <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <HeaderRemoteWork />
        <Outlet />
        <FooterRemoteWork />
      </main>
    </>
  )
}